var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 4.41602C14.6872 5.18402 15.1192 6.24002 15.1192 7.34402C15.0712 9.69602 13.1512 11.616 10.7992 11.568C10.3192 11.568 9.83923 11.472 9.40723 11.328C10.1752 12.192 11.2792 12.72 12.5272 12.72C14.8792 12.768 16.8472 10.848 16.8472 8.49602C16.8472 6.62402 15.6472 5.04002 13.9672 4.41602Z",
    fill: "#57B757",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9515 12.432H11.9035C9.35946 12.384 7.34346 10.32 7.39146 7.824C7.39146 6.624 7.87146 5.472 8.78346 4.608C9.64746 3.744 10.7995 3.264 12.0475 3.312C13.2475 3.312 14.3995 3.792 15.2635 4.704C16.1275 5.568 16.5595 6.72 16.5595 7.968C16.5115 10.416 14.4475 12.432 11.9515 12.432ZM11.9515 3.888C10.8955 3.888 9.93546 4.272 9.16746 5.04C8.39946 5.808 7.96746 6.768 7.96746 7.872C7.91947 10.08 9.69546 11.904 11.9035 11.904C14.1115 11.904 15.9355 10.176 15.9355 7.968C15.9355 6.912 15.5515 5.904 14.7835 5.136C14.0635 4.32 13.0555 3.888 11.9515 3.888C11.9995 3.888 11.9995 3.888 11.9515 3.888Z",
    fill: "#57B757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0961 19.488C18.1441 17.184 16.7041 15.168 14.6881 14.304C15.7441 15.312 16.4161 16.752 16.3681 18.336V19.728H11.9521V20.88H18.0961V19.488Z",
    fill: "#57B757",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2317 20.304V18.912C17.2797 15.984 14.9277 13.632 11.9997 13.584C10.6077 13.584 9.2637 14.112 8.2557 15.072C7.2477 16.032 6.6717 17.376 6.6717 18.768V20.256H6.0957V18.72C6.0957 17.136 6.7197 15.696 7.8717 14.592C8.9757 13.488 10.4637 12.912 11.9997 12.912C15.2157 12.96 17.8077 15.6 17.7597 18.816V20.208H17.2317V20.304Z",
    fill: "#57B757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.1b78c3a74373970d805c988acc26e876.svg";
export { ForwardRef as ReactComponent };